var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"vue"}},[(_vm.$route.name == 'permalink')?_c('div',[_c('router-view')],1):_c('div',[_c('alert',{attrs:{"alert":this.$root.alert}}),_c('router-view',{attrs:{"user":this.$root.user,"name":"navigation"}}),_c('router-view'),_c('foot')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }